<script lang="ts">
  import PanelHeader from "./PanelHeader.svelte";

  export let noBack: boolean = false;
</script>

<div class="lrs-panel">
  <PanelHeader {noBack} on:prev on:next on:back>
    <slot name="header" />
  </PanelHeader>
  <slot />
</div>

<style lang="scss" global>
  .lrs-panel {
    &:first-of-type .lrs-nav-prev {
      visibility: visible;
    }

    &:last-of-type .lrs-nav-next {
      visibility: visible;
    }
  }

  .lrs-panel {
    + .lrs-panel .lrs-panel-weeks {
      border-left: 1px solid rgba(0, 0, 0, 0.08);
    }
  }
</style>
